import { render, staticRenderFns } from "./DashboardWSUTable.vue?vue&type=template&id=2265b6a0&"
import script from "./DashboardWSUTable.vue?vue&type=script&lang=js&"
export * from "./DashboardWSUTable.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWSUTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports